import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import _ from 'lodash';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import getSlug from 'speakingurl';

const FaqAccordion = (props) => {
    
    const renderFAQs = (faqs) => {
        return _.map(faqs, (faq, index) => {
            const faqQuestion = _.get(faq, 'question');
            const faqAnswer = _.get(faq, 'answer');
            const faqVideoUrl = _.get(faq, 'video_url');
            return (

                <Accordion key={index} className='faq-tab-accordion faq-tab-accordion-hover'>

                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: '#fff' }} />}
                        id={`panel${index}-header`}
                        className='faq-tab-accordion-summary'
                    >
                        <p>{faqQuestion}</p>
                    </AccordionSummary>

                    <AccordionDetails className='faq-tab-accordion-details'>
                        <div>
                            <h6 className='faq-tab-answer'>{faqAnswer}</h6>
                            {renderVideo(faqVideoUrl)}
                        </div>
                    </AccordionDetails>

                </Accordion>

            );
        });
    };

    const renderVideo = (faqVideoUrl) => {
        if (!faqVideoUrl) {
            return null;
        }
        return (

            <div className='faq-tab-video-container'>

                <ReactPlayer
                    className="react-player"
                    url={faqVideoUrl}
                    playing={false}
                    width="100%"
                    height={props.isMobile ? 180 : 740}
                    controls
                />

            </div>

        );
    };

    return _.map(props.sections, (section, index) => {
        const sectionHeader = _.get(section, 'section_header');
        const sectionHeaderSlug = getSlug(sectionHeader);
        const faqs = _.get(section, 'faq');
        return (
            <div key={index}>
                <h4 id={sectionHeaderSlug} className='faq-tab-title'>
                    {sectionHeader}
                </h4>
                {renderFAQs(faqs)}
            </div>
        );
    });
};

export default FaqAccordion;

FaqAccordion.propTypes = {
    sections: PropTypes.array,
};
